import React from 'react';
import { Reveal } from '../Reveal';
const loopSteps = ['KeyTurn records what was planned.', 'It observes what actually happened - durations, timing changes, blockers, decisions and outcomes.', 'It compares similar work across your previous projects.', 'It flags where a new plan disagrees with your own experience, and recommends a better approach.', 'Accepted outcomes strengthen your Opening Playbooks and future recommendations.'];
export function Intelligence() {
  return <section id="intelligence" className="bg-charcoal-700" data-id="element-168" data-mp="10yukrjlu4vkc">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-169" data-mp="110fi1gzjaslw">
        <div className="max-w-[720px]" data-id="element-170" data-mp="1ezowab46jcn8">
          <p className="micro-label text-[9px] text-gold-400" data-id="element-171" data-mp="19z0uqvibrder">Compounding intelligence</p>
          <h2 className="mt-4 font-display text-[32px] font-semibold leading-[1.08] tracking-[-0.03em] text-cream sm:text-[40px]" data-id="element-172" data-mp="1a1dl9x25ew3f">
            Your project history becomes your next project’s advantage.
          </h2>
          <p className="mt-5 text-[15.5px] leading-relaxed text-charcoal-200" data-id="element-173" data-mp="3kv1xgf062s10">
            KeyTurn learns how long work really takes, where plans typically stall and which
            interventions succeed across your openings, takeovers and rollouts - then uses that
            experience to challenge unrealistic timing before the date is accepted.
          </p>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16" data-id="element-174" data-mp="3kby0fwbcpiw">
          <Reveal className="rounded-2xl border border-white/10 bg-charcoal-800 p-6 sm:p-8" data-id="element-175" data-mp="322hb7gez3l66">
            <p className="micro-label text-[9px] text-charcoal-300" data-id="element-176" data-mp="37128b6yxhoqe">Recommendation in context</p>
            <p className="mt-4 text-[15px] leading-relaxed text-cream" data-id="element-177" data-mp="3c0n9zp5hgb6t">
              A project team allows four days for a legal review involving twelve parties.
            </p>

            <div className="mt-7 grid grid-cols-2 gap-5" data-id="element-178" data-mp="2jdkdt3oa4cjq">
              <div className="border-l-2 border-clay pl-4" data-id="element-179" data-mp="2oc423aqci0f9">
                <p className="font-display text-[34px] font-semibold leading-none tabular-nums text-clay-300" data-id="element-180" data-mp="2oakltk4ovpdh">
                  4 days
                </p>
                <p className="micro-label mt-3 text-[8.5px] text-charcoal-400" data-id="element-181" data-mp="2bcd1a8kf5ql7">In the new plan</p>
              </div>
              <div className="border-l-2 border-sage pl-4" data-id="element-182" data-mp="2q197e02x0tj6">
                <p className="font-display text-[34px] font-semibold leading-none tabular-nums text-sage-300" data-id="element-183" data-mp="2l2o57v43rzs3">
                  21 days
                </p>
                <p className="micro-label mt-3 text-[8.5px] text-charcoal-400" data-id="element-184" data-mp="1xf6m0nywma0q">
                  Your projects, actual
                </p>
              </div>
            </div>

            <p className="mt-7 border-t border-white/10 pt-5 text-[13.5px] leading-relaxed text-charcoal-200" data-id="element-185" data-mp="27d45yz9qdknj">
              KeyTurn flags the mismatch before the date is accepted and recommends allowing more
              time, beginning earlier, or changing the review approach. Not a generic opinion about
              legal reviews - a read on how your own projects have actually performed.
            </p>
          </Reveal>

          <div data-id="element-186" data-mp="3qa7jqc7oz2ch">
            <ol className="space-y-0" data-id="element-187" data-mp="3q9xp2bbpc70g">
              {loopSteps.map((step, index) => <li key={step} className="flex gap-4 border-b border-white/10 py-4 first:border-t first:border-white/10" data-id="element-188" data-mp="3cag1u0e211t7" data-mpi={index}>
                  <span className="text-[12.5px] font-semibold tabular-nums text-gold-400" data-id="element-189" data-mp="3ge490hyrxvdx">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p className="text-[13.5px] leading-relaxed text-charcoal-200" data-id="element-190" data-mp="cut33jmgfch4">{step}</p>
                </li>)}
            </ol>

            <div className="mt-9" data-id="element-191" data-mp="35hwq4qyclwx">
              <h3 className="font-display text-[21px] font-medium leading-snug tracking-[-0.02em] text-cream" data-id="element-192" data-mp="34g9l1wnw8yu">
                Start from everything your organisation already knows
              </h3>
              <p className="mt-3 max-w-[56ch] text-[13.5px] leading-relaxed text-charcoal-200" data-id="element-193" data-mp="vmu8z5xnc301">
                Build reusable Opening Playbooks for openings, takeovers, refurbishments, brands and
                systems. KeyTurn lands the work against each property’s own milestones, then improves
                the playbook as real outcomes come back.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}